const TravelAndGapIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
        fill="#22D3B6"
      />
      <path
        d="M10 23V24C10 24.2833 9.90417 24.5208 9.7125 24.7125C9.52083 24.9042 9.28333 25 9 25H8C7.71667 25 7.47917 24.9042 7.2875 24.7125C7.09583 24.5208 7 24.2833 7 24V16L9.1 10C9.2 9.7 9.37917 9.45833 9.6375 9.275C9.89583 9.09167 10.1833 9 10.5 9H21.5C21.8167 9 22.1042 9.09167 22.3625 9.275C22.6208 9.45833 22.8 9.7 22.9 10L25 16V24C25 24.2833 24.9042 24.5208 24.7125 24.7125C24.5208 24.9042 24.2833 25 24 25H23C22.7167 25 22.4792 24.9042 22.2875 24.7125C22.0958 24.5208 22 24.2833 22 24V23H10ZM9.8 14H22.2L21.15 11H10.85L9.8 14ZM11.5 20C11.9167 20 12.2708 19.8542 12.5625 19.5625C12.8542 19.2708 13 18.9167 13 18.5C13 18.0833 12.8542 17.7292 12.5625 17.4375C12.2708 17.1458 11.9167 17 11.5 17C11.0833 17 10.7292 17.1458 10.4375 17.4375C10.1458 17.7292 10 18.0833 10 18.5C10 18.9167 10.1458 19.2708 10.4375 19.5625C10.7292 19.8542 11.0833 20 11.5 20ZM20.5 20C20.9167 20 21.2708 19.8542 21.5625 19.5625C21.8542 19.2708 22 18.9167 22 18.5C22 18.0833 21.8542 17.7292 21.5625 17.4375C21.2708 17.1458 20.9167 17 20.5 17C20.0833 17 19.7292 17.1458 19.4375 17.4375C19.1458 17.7292 19 18.0833 19 18.5C19 18.9167 19.1458 19.2708 19.4375 19.5625C19.7292 19.8542 20.0833 20 20.5 20ZM9 21H23V16H9V21Z"
        fill="white"
      />
    </svg>
  )
}

export default TravelAndGapIcon
